module.exports = {
      id: "f05078f1e67dbbaf4cda46f7ef3c6ed9roofShape-hip.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#f05078f1e67dbbaf4cda46f7ef3c6ed9roofShape-hip.svg",
      toString: function () {
        return this.url;
      }
    }